export default {
  beforeMount(el, binding) {
    const regex = binding.value;

    if (!regex) return;

    el._beforeInputHandler = function(e) {
      const newValue = e.target.value.slice(0, e.target.selectionStart) +
        (e.data || '') +
        e.target.value.slice(e.target.selectionEnd);

      if (e.data && !regex.test(newValue)) {
        e.preventDefault();
      }
    };
    el.addEventListener("beforeinput", el._beforeInputHandler);
  },

  beforeUnmount(el) {
    el.removeEventListener("beforeinput", el._beforeInputHandler);
    delete el._beforeInputHandler;
  }
};